module.exports = __webpack_public_path__ + "img/Weissenburg_Logo.9462d19.png";